import React, { useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const footerBgRef = useRef(null);
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    if (!isHomePage) {
      // Remove background image and parallax on non-home pages
      if (footerBgRef.current) {
        footerBgRef.current.style.backgroundImage = 'none';
        footerBgRef.current.style.transform = 'none';
      }
      return;
    }

    const handleScroll = () => {
      if (footerBgRef.current) {
        const scrolled = window.pageYOffset;
        // Parallax effect - moves slower than scroll (creates depth effect)
        // Use 0.5 multiplier like hero sections for more visible effect
        const parallax = scrolled * 0.5;
        footerBgRef.current.style.transform = `translate3d(0, ${parallax}px, 0)`;
      }
    };

    // Ensure the background image is set - force it every time
    if (footerBgRef.current) {
      const imagePath = process.env.PUBLIC_URL 
        ? `${process.env.PUBLIC_URL}/images/topo_map.png`
        : '/images/topo_map.png';
      // Force set the background image properties
      footerBgRef.current.style.setProperty('background-image', `url("${imagePath}")`, 'important');
      footerBgRef.current.style.setProperty('background-size', 'cover', 'important');
      footerBgRef.current.style.setProperty('background-position', 'center', 'important');
      footerBgRef.current.style.setProperty('background-repeat', 'no-repeat', 'important');
    }

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isHomePage]);

  const imagePath = process.env.PUBLIC_URL 
    ? `${process.env.PUBLIC_URL}/images/topo_map.png`
    : '/images/topo_map.png';

  return (
    <footer className={`footer ${!isHomePage ? 'footer-solid' : ''}`}>
      {isHomePage && (
        <div
          className="footer-background"
          ref={footerBgRef}
          style={{
            backgroundImage: `url("${imagePath}")`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
          }}
          aria-hidden="true"
        />
      )}
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>UpNorth Impact</h3>
            <p>Empowering non-profits through strategic consulting and impactful solutions.</p>
          </div>
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/media">Media</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Contact</h4>
            <p>Email: info@upnorthimpact.com</p>
            <p>Phone: 336 287 7878</p>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="footer-copyright">
            <h4 className="footer-tagline">Expose. Educate. Engage.</h4>
            <p>&copy; {new Date().getFullYear()} UpNorth Impact. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
